import { render } from "./LoadingIndicator.vue?vue&type=template&id=63348482"
import script from "./LoadingIndicator.vue?vue&type=script&lang=ts"
export * from "./LoadingIndicator.vue?vue&type=script&lang=ts"

import "./LoadingIndicator.vue?vue&type=style&index=0&id=63348482&lang=scss"
script.render = render

export default script